export const organization = {
  routes: [
    {
      path: "/organization/asset-groups",
      component: () => import("../organization-asset-group-category-asset-group-view"),
    },
  ],
};

// export const ddo = {
//   routes: [
//     {
//       path: "/ddo/asset-groups",
//       component: () => import("../ddo-asset-group-category-asset-group-view"),
//     },
//   ],
// };

// export const bgys = {
//   routes: [
//     {
//       path: "/bgys/asset-groups",
//       component: () => import("../bgys-asset-group-category-asset-group-view"),
//     },
//   ],
// };
